// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-form-form-buttons-form-submit----form-submit-module---wrapper---3cAsP","submit":"src-components-form-form-buttons-form-submit----form-submit-module---submit---1Apl0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/form/form-buttons/form-submit/form-submit.module.css
// module id = 481
// module chunks = 168707334958949